import React from 'react';
import { ArrowLeft, Download } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { personalInfo } from '../data/mockData';
import { Button } from './ui/button';

const ResumeViewer = () => {
  const navigate = useNavigate();

  return (
    <main className="min-h-screen bg-gray-900 text-white">
      <div className="mx-auto flex min-h-screen max-w-7xl flex-col px-4 py-6 sm:px-6 lg:px-8">
        <div className="mb-5 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
          <Button
            onClick={() => navigate('/')}
            variant="outline"
            className="w-full border-gray-600 text-gray-200 hover:bg-gray-800 sm:w-auto"
          >
            <ArrowLeft size={18} className="mr-2" />
            Back
          </Button>

          <Button
            asChild
            className="w-full bg-gradient-to-r from-cyan-500 to-blue-500 font-semibold text-white hover:from-cyan-600 hover:to-blue-600 sm:w-auto"
          >
            <a href={personalInfo.resumeLink} download>
              <Download size={18} className="mr-2" />
              Download Resume
            </a>
          </Button>
        </div>

        <div className="flex-1 overflow-hidden rounded-xl border border-gray-700 bg-gray-800 shadow-2xl">
          <iframe
            src={personalInfo.resumeLink}
            title="Arpan Jain Resume"
            className="h-[calc(100vh-120px)] w-full"
          />
        </div>
      </div>
    </main>
  );
};

export default ResumeViewer;
